import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70e7afd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comments-filters__inputs" }
const _hoisted_2 = { class: "comments-filters__actions" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "comments-filters",
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_the_input, {
        placeholder: "Номер накладной / Номер заказа",
        value: _ctx.state.number,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.number) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата создания с",
        value: _ctx.state.createdAtFrom,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.createdAtFrom) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата создания по",
        value: _ctx.state.createdAtTo,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.createdAtTo) = $event))
      }, null, 8, ["value"]),
      _createVNode(_component_the_select, {
        "can-deselect": "",
        class: "mt-2",
        value: _ctx.state.createdBy,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.createdBy) = $event)),
        placeholder: "Менеджер КЦ",
        loading: _ctx.data_state.managers.is_loading,
        options: _ctx.data_state.managers.list,
        failed: _ctx.data_state.managers.is_failed,
        "error-text": "При получении списка менеджеров произошла ошибка",
        "infinite-scroll": "",
        onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadManagers(_ctx.data_state.managers.pagination.current_page))),
        onLoadmore: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadMoreManagers(_ctx.data_state.managers.pagination.current_page + 1))),
        onSearch: _ctx.searchManagers,
        onOptionBySearch: _ctx.unshiftFindedManager
      }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_button, {
        class: "second text small mt-2",
        disabled: _ctx.loading,
        onClick: _ctx.reset
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary text small mt-2",
        loading: _ctx.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}